import type { SignerConfig, SignerVaultInfo, Hex } from '../types/signers';
import { emblemPost } from './http';

export async function fetchVaultInfo(config: SignerConfig): Promise<SignerVaultInfo> {
  // Note: The server only supports POST for /vault/info
  const data: Partial<{
    vaultId: string;
    address: string;
    evmAddress: Hex;
    created_by?: string;
  }> = await emblemPost('/vault/info', {}, config);

  // Validate required response data (vaultId + evmAddress are required for EVM)
  if (!data || !data.vaultId || !data.evmAddress) {
    throw new Error('Invalid vault info response: missing required fields');
  }

  if (!String(data.evmAddress).startsWith('0x')) {
    throw new Error('Invalid evmAddress format in response');
  }

  return {
    vaultId: data.vaultId,
    tokenId: data.vaultId,
    address: data.address || '', // Solana address may be absent; keep optional
    evmAddress: data.evmAddress as Hex,
    created_by: data.created_by,
  };
}
